import styled from 'styled-components';
import { boxShadow } from 'js/config/style';

export default styled.div`
  //display: grid;
  grid-template-columns: 1fr 1fr;
  grid-gap: 1rem;
  justify-content: center;
  margin-top: 2rem;
  background: white;
  border-radius: 0.25rem;
  box-shadow: ${boxShadow};
  padding: 1.5rem;

  & > div:nth-child(odd) {
    font-weight: bold;
    text-align: left;
  }

  & > div:nth-child(even) {
    text-align: left;
    margin-bottom: 0.5rem
  }
`;

